import * as ReactPortal from "@radix-ui/react-portal"
import { AudioPlayer } from "./audio-player.tsx"
import { useAudioPlayer } from "./use-audio-player.ts"

export function AudioPlayerDrawer() {
  const { currentTrack } = useAudioPlayer()
  if (!currentTrack) return null

  return (
    <ReactPortal.Root>
      <div className="fixed bottom-0 left-0 right-0 z-50">
        <div className="mx-auto w-full max-w-[var(--app-max-width)] bg-background">
          <AudioPlayer />
        </div>
      </div>
    </ReactPortal.Root>
  )
}
